import { render, staticRenderFns } from "./o-large-text.vue?vue&type=template&id=1453807b&scoped=true"
import script from "./o-large-text.vue?vue&type=script&lang=js"
export * from "./o-large-text.vue?vue&type=script&lang=js"
import style0 from "./o-large-text.vue?vue&type=style&index=0&id=1453807b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1453807b",
  null
  
)

export default component.exports